// extracted by mini-css-extract-plugin
module.exports = {"notFoundMain":"NotFound_notFoundMain__1UtsB","errorTitle":"NotFound_errorTitle__2w3ju","errorDesc":"NotFound_errorDesc__2MyOD","notFoundLink":"NotFound_notFoundLink__2EYm1"};